//cannot contain Dates, functions, Infinity, RegExps, Maps, Sets, Blobs, FileLists, ImageDatas, sparse Arrays, Typed Arrays or other complex types
export default {
  user: undefined,
  auth: { passed: false },
  isResetTwoFa: false,
};
